import { render, staticRenderFns } from "./DataRaccolta.vue?vue&type=template&id=02b059dd&scoped=true"
import script from "./DataRaccolta.vue?vue&type=script&lang=js"
export * from "./DataRaccolta.vue?vue&type=script&lang=js"
import style0 from "./DataRaccolta.vue?vue&type=style&index=0&id=02b059dd&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b059dd",
  null
  
)

export default component.exports